<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const defaultHeaderSnippet = `
    <header class="small-header">
      <a class="logo-link" href="/" aria-label="nib">
        <svg height="22" viewBox="0 0 192 64">
          <g clip-path="url(#a)">
            <path 
              d="M86.2561 20.4894C87.7498 18.893 89.5337 17.5951 
              91.5128 16.6647C93.8447 15.4664 96.6762 14.8673 100.007 
              14.8673C102.581 14.8303 105.136 15.3002 107.528 
              16.2503C109.697 17.1199 111.66 18.4347 113.289 20.1099C114.931 
              21.842 116.19 23.9006 116.982 26.1514C117.864 28.6525 118.3 
              31.2887 118.271 33.9404V62.9846H105.539V36.1623C105.539 
              33.3363 104.786 31.0478 103.28 29.297C101.775 27.5461 99.6361
              26.669 96.8645 26.6657C93.7264 26.6657 91.2047 27.5877 89.2992
              29.4318C87.3937 31.2758 86.4426 33.8589 86.446 
              37.1809V62.9946H73.614V15.6961H86.2561V20.4894ZM123.423 
              11.6218V-0.161609H136.265V11.6218H123.423ZM123.423 
              62.9796V15.6961H136.265V62.9946L123.423 62.9796ZM168.085
              63.6237C165.484 63.6449 162.895 63.2831 160.4 62.5502C158.184 61.921 156.104 60.8884
              154.264 59.5045V62.9996H141.412V-0.161609H154.239V19.4758C156.091
              18.0857 158.178 17.0389 160.4 16.3851C162.894 15.6105 165.493
              15.2232 168.105 15.2367C171.26 15.226 174.383 15.8651 177.279 
              17.1141C180.126 18.3296 182.709 20.0864 184.884 22.2868C187.072 
              24.5259 188.824 27.1519 190.051 30.0309C191.352 33.0467 192.016 
              36.2985 192 39.5825C192.031 42.8637 191.37 46.1147 190.061 49.1241C188.823
              51.9564 187.067 54.5334 184.884 56.7234C180.415 61.1472 174.381 63.632 
              168.09 63.6387L168.085 63.6237ZM166.991 52.2996C168.67 52.3075 170.318
              51.9631 171.868 51.316C173.367 50.6974 174.719 49.7702 175.835 48.5948C176.955 
              47.4278 177.851 46.0655 178.478 44.5755C179.82 41.4864 179.879 37.9918 178.645 
              34.8587C177.41 31.7256 174.982 29.21 171.893 27.864C170.35 27.1934 168.683 26.8533 
              167.001 26.8654C165.274 26.8502 163.563 27.1902 161.974 27.864C160.446 28.5156 159.05 
              29.4412 157.856 30.5951C156.674 31.7517 155.733 33.1315 155.088 34.6544C154.42 
              36.2129 154.08 37.8921 154.089 39.5875C154.073 41.3 154.403 42.9981 155.058 
              44.5805C155.694 46.1032 156.624 47.4855 157.795 48.6482C158.966 49.8109 160.356 
              50.7311 161.884 51.3559C163.508 52.0013 165.243 52.322 166.991 52.2996ZM37.4766 
              13.0498V-0.361328H25.7339V13.0498L31.6052 18.9166L37.4766 13.0498ZM49.7839 
              37.086H63.2055V25.3525H49.7839L43.9126 31.2193L49.7839 37.086ZM48.6096 22.5215L58.1037 
              13.0348L49.7989 4.7415L40.3048 14.2282V22.5215H48.6096ZM40.3098 48.2104L49.8039 57.697L58.1087 
              49.3987L48.6146 39.912H40.3098V48.2104ZM22.9007 14.2232L13.4066 4.7365L5.10681 13.0348L14.6009 
              22.5215H22.9007V14.2232ZM37.4766 25.3525H0V37.086H17.4291L5.10681 49.3987L13.4066 57.697L25.7339 
              45.3793V62.7949H37.4766V25.3475V25.3525Z" fill="currentColor"/>
          </g>
          <defs>
            <clipPath id="a">
              <path fill="currentColor" d="M0 0H192V64H0z"/>
            </clipPath>
          </defs>
        </svg>
      </a>
    </header>
  `;

  const invertedHeaderSnippet = `
    <header class="small-header inverted-header">
      <a class="logo-link" href="/" aria-label="nib">
        <svg height="22" viewBox="0 0 192 64">
          <g clip-path="url(#a)">
            <path 
              d="M86.2561 20.4894C87.7498 18.893 89.5337 17.5951 
              91.5128 16.6647C93.8447 15.4664 96.6762 14.8673 100.007 
              14.8673C102.581 14.8303 105.136 15.3002 107.528 
              16.2503C109.697 17.1199 111.66 18.4347 113.289 20.1099C114.931 
              21.842 116.19 23.9006 116.982 26.1514C117.864 28.6525 118.3 
              31.2887 118.271 33.9404V62.9846H105.539V36.1623C105.539 
              33.3363 104.786 31.0478 103.28 29.297C101.775 27.5461 99.6361
              26.669 96.8645 26.6657C93.7264 26.6657 91.2047 27.5877 89.2992
              29.4318C87.3937 31.2758 86.4426 33.8589 86.446 
              37.1809V62.9946H73.614V15.6961H86.2561V20.4894ZM123.423 
              11.6218V-0.161609H136.265V11.6218H123.423ZM123.423 
              62.9796V15.6961H136.265V62.9946L123.423 62.9796ZM168.085
              63.6237C165.484 63.6449 162.895 63.2831 160.4 62.5502C158.184 61.921 156.104 60.8884
              154.264 59.5045V62.9996H141.412V-0.161609H154.239V19.4758C156.091
              18.0857 158.178 17.0389 160.4 16.3851C162.894 15.6105 165.493
              15.2232 168.105 15.2367C171.26 15.226 174.383 15.8651 177.279 
              17.1141C180.126 18.3296 182.709 20.0864 184.884 22.2868C187.072 
              24.5259 188.824 27.1519 190.051 30.0309C191.352 33.0467 192.016 
              36.2985 192 39.5825C192.031 42.8637 191.37 46.1147 190.061 49.1241C188.823
              51.9564 187.067 54.5334 184.884 56.7234C180.415 61.1472 174.381 63.632 
              168.09 63.6387L168.085 63.6237ZM166.991 52.2996C168.67 52.3075 170.318
              51.9631 171.868 51.316C173.367 50.6974 174.719 49.7702 175.835 48.5948C176.955 
              47.4278 177.851 46.0655 178.478 44.5755C179.82 41.4864 179.879 37.9918 178.645 
              34.8587C177.41 31.7256 174.982 29.21 171.893 27.864C170.35 27.1934 168.683 26.8533 
              167.001 26.8654C165.274 26.8502 163.563 27.1902 161.974 27.864C160.446 28.5156 159.05 
              29.4412 157.856 30.5951C156.674 31.7517 155.733 33.1315 155.088 34.6544C154.42 
              36.2129 154.08 37.8921 154.089 39.5875C154.073 41.3 154.403 42.9981 155.058 
              44.5805C155.694 46.1032 156.624 47.4855 157.795 48.6482C158.966 49.8109 160.356 
              50.7311 161.884 51.3559C163.508 52.0013 165.243 52.322 166.991 52.2996ZM37.4766 
              13.0498V-0.361328H25.7339V13.0498L31.6052 18.9166L37.4766 13.0498ZM49.7839 
              37.086H63.2055V25.3525H49.7839L43.9126 31.2193L49.7839 37.086ZM48.6096 22.5215L58.1037 
              13.0348L49.7989 4.7415L40.3048 14.2282V22.5215H48.6096ZM40.3098 48.2104L49.8039 57.697L58.1087 
              49.3987L48.6146 39.912H40.3098V48.2104ZM22.9007 14.2232L13.4066 4.7365L5.10681 13.0348L14.6009 
              22.5215H22.9007V14.2232ZM37.4766 25.3525H0V37.086H17.4291L5.10681 49.3987L13.4066 57.697L25.7339 
              45.3793V62.7949H37.4766V25.3475V25.3525Z" fill="currentColor"/>
          </g>
          <defs>
            <clipPath id="a">
              <path fill="currentColor" d="M0 0H192V64H0z"/>
            </clipPath>
          </defs>
        </svg>
      </a>
    </header>
  `;

  const headerWithLinksSnippet = `
    <header class="small-header">
      <div class="left-header">
        <div class="inline-block p-4 space-x-4">
          <a href="#" class="link">Link 1</a>
          <a href="#" class="link">Link 2</a>
        </div>
      </div>
      <div class="middle-header">
        <a class="logo-link" href="/" aria-label="nib">
          <svg height="22" viewBox="0 0 192 64">
            <g clip-path="url(#a)">
              <path 
                d="M86.2561 20.4894C87.7498 18.893 89.5337 17.5951 
                91.5128 16.6647C93.8447 15.4664 96.6762 14.8673 100.007 
                14.8673C102.581 14.8303 105.136 15.3002 107.528 
                16.2503C109.697 17.1199 111.66 18.4347 113.289 20.1099C114.931 
                21.842 116.19 23.9006 116.982 26.1514C117.864 28.6525 118.3 
                31.2887 118.271 33.9404V62.9846H105.539V36.1623C105.539 
                33.3363 104.786 31.0478 103.28 29.297C101.775 27.5461 99.6361
                26.669 96.8645 26.6657C93.7264 26.6657 91.2047 27.5877 89.2992
                29.4318C87.3937 31.2758 86.4426 33.8589 86.446 
                37.1809V62.9946H73.614V15.6961H86.2561V20.4894ZM123.423 
                11.6218V-0.161609H136.265V11.6218H123.423ZM123.423 
                62.9796V15.6961H136.265V62.9946L123.423 62.9796ZM168.085
                63.6237C165.484 63.6449 162.895 63.2831 160.4 62.5502C158.184 61.921 156.104 60.8884
                154.264 59.5045V62.9996H141.412V-0.161609H154.239V19.4758C156.091
                18.0857 158.178 17.0389 160.4 16.3851C162.894 15.6105 165.493
                15.2232 168.105 15.2367C171.26 15.226 174.383 15.8651 177.279 
                17.1141C180.126 18.3296 182.709 20.0864 184.884 22.2868C187.072 
                24.5259 188.824 27.1519 190.051 30.0309C191.352 33.0467 192.016 
                36.2985 192 39.5825C192.031 42.8637 191.37 46.1147 190.061 49.1241C188.823
                51.9564 187.067 54.5334 184.884 56.7234C180.415 61.1472 174.381 63.632 
                168.09 63.6387L168.085 63.6237ZM166.991 52.2996C168.67 52.3075 170.318
                51.9631 171.868 51.316C173.367 50.6974 174.719 49.7702 175.835 48.5948C176.955 
                47.4278 177.851 46.0655 178.478 44.5755C179.82 41.4864 179.879 37.9918 178.645 
                34.8587C177.41 31.7256 174.982 29.21 171.893 27.864C170.35 27.1934 168.683 26.8533 
                167.001 26.8654C165.274 26.8502 163.563 27.1902 161.974 27.864C160.446 28.5156 159.05 
                29.4412 157.856 30.5951C156.674 31.7517 155.733 33.1315 155.088 34.6544C154.42 
                36.2129 154.08 37.8921 154.089 39.5875C154.073 41.3 154.403 42.9981 155.058 
                44.5805C155.694 46.1032 156.624 47.4855 157.795 48.6482C158.966 49.8109 160.356 
                50.7311 161.884 51.3559C163.508 52.0013 165.243 52.322 166.991 52.2996ZM37.4766 
                13.0498V-0.361328H25.7339V13.0498L31.6052 18.9166L37.4766 13.0498ZM49.7839 
                37.086H63.2055V25.3525H49.7839L43.9126 31.2193L49.7839 37.086ZM48.6096 22.5215L58.1037 
                13.0348L49.7989 4.7415L40.3048 14.2282V22.5215H48.6096ZM40.3098 48.2104L49.8039 57.697L58.1087 
                49.3987L48.6146 39.912H40.3098V48.2104ZM22.9007 14.2232L13.4066 4.7365L5.10681 13.0348L14.6009 
                22.5215H22.9007V14.2232ZM37.4766 25.3525H0V37.086H17.4291L5.10681 49.3987L13.4066 57.697L25.7339 
                45.3793V62.7949H37.4766V25.3475V25.3525Z" fill="currentColor"/>
            </g>
            <defs>
              <clipPath id="a">
                <path fill="currentColor" d="M0 0H192V64H0z"/>
              </clipPath>
            </defs>
          </svg>
        </a>
      </div>
      <div class="right-header">
        <div class="inline-block p-4">
          <a href="#" class="link">Logout</a>
        </div>
      </div>
    </header>
  `;
</script>

<template>
  <section id="small-header" class="page-section bg-lightest">
    <div class="container">
      <h2 class="heading heading-2 my-6">Small Header</h2>

      <h3 class="heading heading-3 mt-8 mb-6">Default Header</h3>
      {@html defaultHeaderSnippet}
      <CodeSnippet id="small-header" snippet={defaultHeaderSnippet} />

      <h3 class="heading heading-3 mt-8 mb-6">Inverted Header</h3>
      {@html invertedHeaderSnippet}
      <CodeSnippet id="small-header-alt" snippet={invertedHeaderSnippet} />

      <h3 class="heading heading-3 mt-8 mb-6">Header with links</h3>
      {@html headerWithLinksSnippet}
      <CodeSnippet id="small-header-alt-links" snippet={headerWithLinksSnippet} />
    </div>
  </section>
</template>
